import EmojiEmbrassedIcon from './emoji_embrassed.svg';

export { EmojiEmbrassedIcon };
